import styled from "styled-components";

export const HeaderContainer = styled.header<{ scrolled: boolean }>`
  position: fixed;
  width: 100vw;
  justify-content: space-between;
  z-index: 10;
  display: flex;
  height: 10vh;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background-color: ${(props) => (props.scrolled ? "#09111a" : "transparent")};
  transition: background-color 140ms ease-in-out;
  /* color: #275c8c; */
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;

  .logo {
    display: flex;
    gap: 1rem;
    padding-left: 5rem;
    padding-top: 1rem;
    font-size: 2rem;
    font-weight: 800;
  }
  .logo p:nth-child(2) {
    color: #ff8412;
  }
  .logo p:nth-child(3) {
    color: #2072bf;
  }

  nav {
    padding-right: 5rem;
    li {
      display: flex;
      margin-left: 1rem;
      list-style: none;
      .contact-button {
        height: 2rem;
        padding: 0 1.5rem 0 1.5rem;
        align-self: center;
        background-color: #ff8412;
        border-radius: 0.35rem;
        border: #172736;
        font-size: 1.25rem;
        font-weight: 500;
        color: #fff;
      }
      .contact-button:hover {
        background-color: #a76323;
        color: #ded9e0;
        cursor: pointer;
      }
    }
  }
`;
